import type { CreationDate } from './types';
import { creationDateSchema } from './types';

export function assertCreationDateMarker(name: unknown): asserts name is CreationDate {
  creationDateSchema.parse(name);
}
